<template>
  <div class="product-introduction-view">
    <div class="question-container">
      <div 
        v-for="(question, index) in questions" 
        :key="index"
        class="question-item"
      >
        <div class="title">
          <div class="title-text">{{ question.title }}</div>
        </div>
        <div class="answer">
          <template v-if="question.answers">
            <div 
              v-for="(item, answerIndex) in question.answers" 
              :key="answerIndex"
              class="answer-item"
            >
              {{ item }}
            </div>
            <div v-if="question.content" class="answer-content">
              {{ question.content }}
            </div>
          </template>
          <template v-else>
            {{ question.answer }}
          </template>
        </div>
      </div>
    </div>
    <HomeFooter v-if="showFooter" />
  </div>
</template>

<script>
import HomeFooter from '@/components/HomeFooter/HomeFooter.vue';

export default {
  name: 'ProductIntroduction',
  components: {
    HomeFooter,
  },
  computed: {
    showFooter() {
      // 从当前路由和父路由中查找 showFooter
      const { matched } = this.$route;
      for (let i = matched.length - 1; i >= 0; i -= 1) {
        if (matched[i].meta?.showFooter !== undefined) {
          return matched[i].meta.showFooter;
        }
      }
      return false;
    },
  },
  data() {
    return {
      questions: [
        {
          title: '松鼠互娱是什么',
          answer: '松鼠互娱是LED大屏场景下用户通过手机微信参与的酒吧大屏互动服务平台，只需一块大屏幕和一台电脑就能引爆现场气氛。可以将线下用户转化为线上粉丝，适用于各类酒吧、清吧、餐吧、夜店等泛娱乐场所。',
        },
        {
          title: '现场用户如何参与大屏幕互动',
          answer: '用户使用微信扫一扫，扫描大屏幕二维码参与互动，或者可以通过让用户关注企业公众号，参与互动。',
        },
        {
          title: '现场用户如何参与大屏幕互动',
          answer: '用户使用微信扫一扫，扫描大屏幕二维码参与互动，或者可以通过让用户关注企业公众号，参与互动。',
        },
        {
          title: '如何使用',
          answer: '访问官网，咨询客服注册账号后，创建活动后对活动进行大屏幕的配置，并参考《使用帮助》尽快进行测试操作，如您在使用过程中遇到任何问题，请联系我们的客服人员。',
        },
        {
          title: '现场设备',
          answers: [
            '方案1：现场准备一台电脑：用于大屏幕展示，链接LED大屏幕，需联网，均需安装现代浏览器（推荐使用Chrome浏览器）；',
            '方案2：现场准备一台电脑，在投影时可以采用扩展模式，扩展桌面用于大屏幕展示，电脑桌面用于信息审核',
          ],
          content: '网络要求：20M，建议连接大屏幕电脑的网络单独提供（如：4G热点），不要与现场WIFI混在一起，以免现场用户太多导致网络拥塞，从而影响了现场效果。',
        },
        {
          title: '投影分辨率',
          answer: '为了确保最佳显示效果，我们建议投影使用的分辨率为1024 X 768，1366 X 768，1920 X 1080',
        },
        {
          title: '正式获得前需要哪些准备',
          answer: '建议在大屏幕直播前做一下调试工作，现场的投影、网络、手机网络最好经过测试验证。',
        },
        {
          title: '包含功能',
          answer: '背景&音乐 、签到 、手写签到 、启动仪式 、倒计时 、Logo签到 、3D签到 、签到欢迎页 、自定义版权 、霸屏 、抢荭包 、弹幕 、消息上墙 、荭包雨 、语音夺宝 、经典抽奖 、炫酷抽奖 、摇奖机 、名单抽奖 、3D抽奖 、拔河 、赛车 、数钱 、马拉松 、龙舟(团队赛) 、龙舟(个人赛) 、吃月饼 、点歌 、摇骰子游戏等。',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.product-introduction-view {
  position: relative;
  z-index: 0;
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
}

.question-container {
  width: 1152px;
}

.question-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-top: 74px;
}

.title {
  display: flex;
  flex-direction: row;
  align-items: center;
  
  .title-text {
    position: relative;
    padding-left: 19px;
    font-weight: 700;
    font-size: 32px;
    line-height: 46px;
    text-align: left;
    background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 9px;
      height: 34px;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
    }
  }
}

.answer {
  margin-top: 20px;
  width: 100%;
  padding: 20px 25px;
  background: linear-gradient(90deg, rgba(102,27,135,0.8) 0%, rgba(20,79,139,0.8) 100%);
  border-radius: 12px;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 30px;
  text-align: justify;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  
  .answer-item {
    position: relative;
    padding-left: 30px;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: justify;
    word-wrap: break-word;
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 7.5px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: #FFFFFF;
    }
  }
  
  .answer-content {
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: justify;
    word-wrap: break-word;
  }
}
</style>
